import ApiService from '../../service/apiServiceIdentity.js';
import ApiServiceMasterCache from '../../service/apiServiceMasterCache.js';

const querystring = require('querystring')
var RoleService = {

    findAll: function($data,$listPage) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "roles"
            $options.method = "get"

            if ($data) {
                $options.url = "roles?" + querystring.stringify($data)
                console.log($options.url)
            }
            ApiServiceMasterCache.request($options,'role',$listPage ? 'list' : null)
            .then(response => {
                console.log('test');
                resolve(response.data.data)
            }).catch(error => {
                reject(error);
            })
        });

    },

    getAccessForRule: function($data,$listPage) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "getAccessForRule"
            $options.method = "get"

            if ($data) {
                $options.url = "getAccessForRule?" + querystring.stringify($data)
                console.log($options.url)
            }
            ApiService.request($options,'role',$listPage ? 'list' : null)
            .then(response => {
                console.log('test');
                resolve(response.data.data)
            }).catch(error => {
                reject(error);
            })
        });

    },

    getReporterData: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "getReporterData"
            $options.method = "get"

            if ($data) {
                $options.url = "getReporterData?" + querystring.stringify($data)
                console.log($options.url)
            }
            ApiService.request($options)
            .then(response => {
                console.log('test');
                resolve(response.data.data)
            }).catch(error => {
                reject(error);
            })
        });

    },
  
    findOne: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "roles/" + $data.id
            console.log($options.url)
            $options.method = "get"
            if (!$data) {
                $options.data = $data
            }
            ApiServiceMasterCache.request($options)
                .then(response => {
                    // console.log('Gpt the data');
                    resolve(response.data.data)
                }).catch(error => {
                    reject(error);
                })
        });

    },
    update: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.data = $data
            $options.url = "roles/" + $data.id;
            $options.method = "post"
            console.log($options)
            ApiService.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
        })
    },
    save: function($data) {
        return new Promise(function(resolve, reject) {
            var $options = {};
            $options.data = $data
            $options.url = "roles" + $data.id;
            $options.method = "post"
            console.log($options)
            ApiService.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
        });
    },

    create: function($data) {
        return new Promise(function(resolve, reject) {
            var $options = {};
            $options.data = $data
            console.log($options,"888")
            $options.url = "roles";
            $options.method = "post"
            console.log($options)
            ApiService.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
        });
    }
};
export default RoleService;